import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { useRegister } from '@/lib/api/orval/target/auth/auth';
import { getAuthStore } from '@/stores/authStore';
import { errorMessage } from '@/lib/errors';

export function Register(): React.ReactElement {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    email: '',
    username: '',
    display_name: '',
    password: '',
  });

  const register = useRegister({
    mutation: {
      onSuccess: (user) => {
        getAuthStore().getState().setUser(user);
        navigate('/machines/mine');
      },
    },
  });

  function update(field: keyof typeof form) {
    return (e: React.ChangeEvent<HTMLInputElement>) =>
      setForm((prev) => ({ ...prev, [field]: e.target.value }));
  }

  return (
    <div className="max-w-sm mx-auto themed-card p-6 flex flex-col gap-4">
      <h1 className="text-2xl font-semibold">Create your account</h1>
      <form
        className="flex flex-col gap-3"
        onSubmit={(e) => {
          e.preventDefault();
          register.mutate({ data: form });
        }}
      >
        <input
          className="themed-input"
          type="email"
          placeholder="Email"
          value={form.email}
          onChange={update('email')}
          required
        />
        <input
          className="themed-input"
          placeholder="Username"
          value={form.username}
          onChange={update('username')}
          required
        />
        <input
          className="themed-input"
          placeholder="Display name"
          value={form.display_name}
          onChange={update('display_name')}
        />
        <input
          className="themed-input"
          type="password"
          placeholder="Password"
          value={form.password}
          onChange={update('password')}
          required
        />
        <button className="btn-primary" type="submit" disabled={register.isPending}>
          {register.isPending ? 'Creating…' : 'Sign up'}
        </button>
      </form>
      {register.isError && (
        <p style={{ color: 'var(--danger)' }}>{errorMessage(register.error)}</p>
      )}
      <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
        Already have an account? <Link to="/login">Log in</Link>
      </p>
    </div>
  );
}
